import React, { useEffect, useRef, useContext, useCallback } from "react"
import "./emoji.css"
import { SocketContext } from "../../context/SocketContext"

const emojiArray = ["👍", "😄", "❤️", "👏"]

const FloatingEmoji = ({ stylex, type, clapsound }) => {
  const obj = JSON.parse(localStorage.getItem("authUser"))
  const { socket } = useContext(SocketContext)
  const clapSoundRef = useRef(null)

  const playClapSound = () => {
    if (clapSoundRef.current) {
      clapSoundRef.current.currentTime = 0
      clapSoundRef.current.play()
    }
  }

  const emojii = (emojiIndex, userName) => {
    const button = document.querySelector(`button[class="${emojiIndex}"]`)
    const container = document.querySelector(".emoji-container")
    if (!button || !container) return

    const emojiEl = document.createElement("div")
    emojiEl.classList.add("emoji-animate")

    emojiEl.innerHTML = `
      <div class="emoji">${button.innerHTML}</div>
      <div class="username">${userName}</div>
    `

    container.appendChild(emojiEl)

    const { height, left } = button.getBoundingClientRect()
    const { bottom, top, width } = container.getBoundingClientRect()

    const animation = emojiEl.animate(
      [
        {
          opacity: 1,
          transform: `translate(${left - 40}px, ${bottom - 10}px)`,
        },
        {
          opacity: 0,
          transform: `translate(${width / 10}px, ${top - height}px)`,
        },
      ],
      {
        duration: 2100,
        easing: "cubic-bezier(.17,.67,.83,.67)",
      }
    )

    animation.onfinish = () => emojiEl.remove()
  }


  const handleEmojiClick = useCallback(
    (emojiIndex) => {
      if (!socket) return

      const emojiData = {
        emojiIndex,
        id: obj?._id,
        Firstname: obj?.Firstname,
      }

      if (emojiArray[emojiIndex] === "👏") playClapSound()
      if (type === "broadcast") {
        socket.emit("emojireact", emojiData)
      }

      emojii(emojiIndex, "You")
    },
    [socket, obj, type]
  )

  useEffect(() => {
    if (!socket) return

    const handler = (emojiData) => {
      if (emojiData?.id === obj?._id) return

      if (emojiArray[emojiData.emojiIndex] === "👏") playClapSound()
      emojii(emojiData.emojiIndex, emojiData.Firstname)
    }

    socket.on("emojireactresponse", handler)

    return () => {
      socket.off("emojireactresponse", handler)
    }
  }, [socket, obj?._id])

  return (
    <>
      {clapsound && (
        <audio
          ref={clapSoundRef}
          src={
            "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/" +
            encodeURIComponent(clapsound) +
            "?alt=media"
          }
          preload="auto"
        />
      )}

      <div
        className="emoji-list"
        style={{
          top: stylex?.coords?.top || "90%",
          left: stylex?.coords?.left || "40%",
        }}
      >
        <ul>
          {emojiArray.map((emoji, index) => (
            <li key={index}>
              <button className={index} onClick={() => handleEmojiClick(index)}>
                {emoji}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

export default FloatingEmoji
